import React from 'react'
import { Moon, Sun, DollarSign } from 'lucide-react'
import { useCurrencyStore } from '@/stores/currencyStore'
import { useTheme } from '@/hooks/useTheme'
import { formatTimeAgo } from '@/utils/formatters'

const Header: React.FC = () => {
  const { lastUpdate } = useCurrencyStore()
  const { isDark, toggleTheme } = useTheme()

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 transition-colors duration-200">
      <div className="flex items-center justify-between">
        {/* Logo and Status */}
        <div className="flex items-center space-x-4">
          {/* Logo */}
          <div className="flex items-center">
            <DollarSign className="w-8 h-8 text-primary-600 dark:text-primary-400" />
            <span className="ml-2 text-xl font-bold text-gray-900 dark:text-white">
              CurrencyPro
            </span>
          </div>
          
          {/* Status Indicator */}
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-600 dark:text-gray-400">Live Rates</span>
            </div>
            {lastUpdate && (
              <span className="text-xs text-gray-500 dark:text-gray-500">
                • Updated {formatTimeAgo(lastUpdate)}
              </span>
            )}
          </div>
        </div>

        {/* Theme Toggle */}
        <button
          onClick={toggleTheme}
          className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </button>
      </div>
    </header>
  )
}

export default Header